

























































































































































































































































































































































































































































































































































import { ClasseScolaireDocument } from "@/models/ClasseScolaireDocument";
import { EnseignantScolaireDocument } from "@/models/EnseignantScolaireDocument";
import { NiveauScolaireDocument } from "@/models/NiveauScolaireDocument";
import { FiltrePointage } from "@/models/_FiltresPointage";
import { FiltreScolarite } from "@/models/_FiltresScolarite";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import bFormSlider from "vue-bootstrap-slider/es/form-slider";
import { Vue } from "vue-property-decorator";
import FiltreBox from "./box.vue";
export default Vue.extend({
  components: { FiltreBox, bFormSlider },
  data() {
    return {
      ageMin: 0,
      ageMax: 100,
      ecoleSelected: [] as Array<number>,
      classeSelected: [] as Array<number>,
      institSelected: [] as Array<number>,
      niveauSelected: [] as Array<number>,
      tempsSelected: [] as Array<number>,
      villeSelected: [] as Array<number>,
      groupesSelected: [] as Array<string>,
      supplementsSelected: [] as Array<number>,
      filtredListNiveau: [] as Array<NiveauScolaireDocument>,
      filtredListClasse: [] as Array<ClasseScolaireDocument>,
      filtredListEnseignant: [] as Array<EnseignantScolaireDocument>,
      pointageSelected: "",
      rangeValue: [0, 100],
      isEcoleFilterApplied: false,
      isNiveauClasse: false,
      isClasseInstit: false,
    };
  },
  mounted() {
    this.tempsSelected = (this.filtrePointage as FiltrePointage)
      .getListTemps()
      .map((temps: any) => temps.getId());
    this.supplementsSelected = (this.filtrePointage as FiltrePointage)
      .getListSuppplements()
      .map((supp: any) => supp.getId());
    this.resetNiveau();
    this.resetClasse();
    this.resetEnseignant();
  },
  methods: {
    clearFiltre(filtre: string) {
      switch (filtre) {
        case "age": {
          this.ageMin = 0;
          this.ageMax = 100;
          this.rangeValue = [0, 100];
          break;
        }
        case "ecoles": {
          this.ecoleSelected = [] as Array<number>;
          break;
        }
        case "classes": {
          this.classeSelected = [] as Array<number>;
          break;
        }
        case "niveau": {
          this.niveauSelected = [] as Array<number>;
          break;
        }
        case "ville": {
          this.villeSelected = [] as Array<number>;
          break;
        }
        case "instit": {
          this.institSelected = [] as Array<number>;
          break;
        }
        case "temps": {
          this.tempsSelected = [] as Array<number>;
          this.tempsSelected = (this.filtrePointage as FiltrePointage)
            .getListTemps()
            .map((temps: any) => temps.getId());
          this.supplementsSelected = (this.filtrePointage as FiltrePointage)
            .getListSuppplements()
            .map((supp: any) => supp.getId());
          break;
        }
        case "pointage": {
          this.pointageSelected = "";
          break;
        }
        case "groupes": {
          this.groupesSelected = [] as Array<string>;
          break;
        }
        default:
          break;
      }

      this.$emit("close-filtre", filtre);
    },
    closePanel(filtre: string) {
      this.clearFiltre(filtre);
      this.$emit("close-panel");
    },
    emitFiltres(typeFiltre: string, value: any) {
      console.log(value);
      let params = {
        filtre: typeFiltre,
        value: value,
      };
      if (value.length === 0 || value === "") {
        this.clearFiltre(typeFiltre);
      } else {
        if (typeFiltre === "temps") this.clearFiltre("pointage");
        this.$emit("filtres", params);
      }
    },
    addEcoles(ecole: number) {
      if (this.ecoleSelected.includes(ecole)) {
        let index = this.ecoleSelected.indexOf(ecole);
        this.ecoleSelected.splice(index, 1);
      } else {
        this.ecoleSelected.push(ecole);
      }
    },
    addClasses(classe: number) {
      if (this.classeSelected.includes(classe)) {
        let index = this.classeSelected.indexOf(classe);
        this.classeSelected.splice(index, 1);
      } else {
        this.classeSelected.push(classe);
      }
    },
    addNiveau(niveau: number) {
      if (this.niveauSelected.includes(niveau)) {
        let index = this.niveauSelected.indexOf(niveau);
        this.niveauSelected.splice(index, 1);
      } else {
        this.niveauSelected.push(niveau);
      }
    },
    addInstit(instit: number) {
      if (this.institSelected.includes(instit)) {
        let index = this.institSelected.indexOf(instit);
        this.institSelected.splice(index, 1);
      } else {
        this.institSelected.push(instit);
      }
    },
    addTemps(temps: number) {
      if (this.tempsSelected.includes(temps)) {
        let index = this.tempsSelected.indexOf(temps);
        this.tempsSelected.splice(index, 1);
      } else {
        this.tempsSelected.push(temps);
      }
    },
    addPointage(pointage: string) {
      this.pointageSelected = pointage;
    },
    addGroupes(groupe: string) {
      if (this.groupesSelected.includes(groupe)) {
        let index = this.groupesSelected.indexOf(groupe);
        this.groupesSelected.splice(index, 1);
      } else {
        this.groupesSelected.push(groupe);
      }
    },
    addVille(ville: any) {
      const villeId = ville.getId();
      if (this.villeSelected.includes(villeId)) {
        const index = this.villeSelected.indexOf(villeId);
        this.villeSelected.splice(index, 1);
      } else {
        this.villeSelected.push(villeId);
      }
    },
    addSupplements(supp: number) {
      if (this.supplementsSelected.includes(supp)) {
        let index = this.supplementsSelected.indexOf(supp);
        this.supplementsSelected.splice(index, 1);
      } else {
        this.supplementsSelected.push(supp);
      }
    },
    filtreEcoles(){
      return (this.filtreScolarite as FiltreScolarite).getListEcoles().filter((item : any)=> !item.obsolete)
    },
    filtreNiveau() {
      let niveauId = (this.filtreScolarite as FiltreScolarite)
        .getListEtablissementScolaireNiveau()
        .filter((item: any) =>
          this.ecoleSelected.includes(item.etablissementscolaire_id)
        )
        .map((item: any) => item.niveauscolaire_id);
      this.filtredListNiveau = (this.filtreScolarite as FiltreScolarite)
        .getListNiveau()
        .filter((item: any) =>
          niveauId.includes(item.id) && !item.obsolete
        ) as Array<NiveauScolaireDocument>;
    },
    resetNiveau() {
      this.filtredListNiveau = (
        this.filtreScolarite as FiltreScolarite
      ).getListNiveau().filter((item : any) => !item.obsolete);
    },
    filtreClasse() {
      if(!this.isEcoleFilterApplied && !this.isNiveauClasse){
        this.resetClasse()
        return
      }
      let classeId = (this.filtreScolarite as FiltreScolarite)
        .getListClasseScolaireNiveau()
        .filter((item: any) =>
          this.niveauSelected.includes(item.niveauscolaire_id)
        )
        .map((item: any) => item.classescolaire_id);

      const anneeScolaire = (this.filtreScolarite as FiltreScolarite).getCurrentAnneeScolaire();
      const anneeScolaireId = anneeScolaire && typeof anneeScolaire.getId === 'function' ? anneeScolaire.getId() : null;

      this.filtredListClasse = (this.filtreScolarite as FiltreScolarite)
        .getListClasses()
        .filter((item: any) =>{
          let isClasseValid = !item.obsolete && anneeScolaireId === item.anneeScolaire_id
          if(this.isEcoleFilterApplied) isClasseValid = isClasseValid && this.ecoleSelected.includes(item.etablissementscolaire_id) 
          if(this.isNiveauClasse) isClasseValid= isClasseValid && classeId.length > 0 && classeId.includes(item.id)
          return isClasseValid;
          }) as Array<ClasseScolaireDocument>;
    },
    resetClasse() {
      const anneeScolaire = (this.filtreScolarite as FiltreScolarite).getCurrentAnneeScolaire();
      const anneeScolaireId = anneeScolaire && typeof anneeScolaire.getId === 'function' ? anneeScolaire.getId() : null;
      
      this.filtredListClasse = (
        this.filtreScolarite as FiltreScolarite
        ).getListClasses().filter((item : any)=> !item.obsolete && anneeScolaireId === item.anneeScolaire_id) as Array<ClasseScolaireDocument>;
    },
    /*DossierHasNotGSModule(){
      return this.filtredListClasse.every((classe:any)=> classe.getAnneeScolaireId() === undefined)
    },*/
    filtreEnseignant() {
      const classesIds = this.filtredListClasse.map(item => item.getId());
      let enseignantId = (this.filtreScolarite as FiltreScolarite)
        .getListClasseScolaireEnseignant()
        .filter((item: any) =>
        classesIds.includes(item.classescolaire_id)
        )
        .map((item: any) => item.enseignant_id);
      this.filtredListEnseignant = (this.filtreScolarite as FiltreScolarite)
        .getListInstits()
        .filter((item: any) =>
          enseignantId.includes(item.id)  && !item.obsolete
        ) as Array<EnseignantScolaireDocument>;
    },
    resetEnseignant() {
      this.filtredListEnseignant = (
        this.filtreScolarite as FiltreScolarite
      ).getListInstits().filter((item : any)=> !item.obsolete)  as Array<EnseignantScolaireDocument>;
      },
  },
  watch: {
    rangeValue(val) {
      this.ageMin = val[0];
      this.ageMax = val[1];
    },
    resetAll(newval: boolean, oldval: boolean) {
      console.log(newval, oldval);
      if (newval) {
        this.ageMin = 0;
        this.ageMax = 100;
        this.rangeValue = [0, 100];
        this.ecoleSelected = [] as Array<number>;
        this.classeSelected = [] as Array<number>;
        this.niveauSelected = [] as Array<number>;
        this.villeSelected = [] as Array<number>;
        this.institSelected = [] as Array<number>;
        this.tempsSelected = [] as Array<number>;
        this.tempsSelected = (this.filtrePointage as FiltrePointage)
          .getListTemps()
          .map((temps: any) => temps.getId());
        this.supplementsSelected = (this.filtrePointage as FiltrePointage)
          .getListSuppplements()
          .map((supp: any) => supp.getId());
        this.pointageSelected = "";
        this.groupesSelected = [] as Array<string>;
        this.$emit("resetDone");
      }
    },
    ecoleSelected(newval: Array<number>, oldval: Array<number>) {
      if (newval.length !== 0) {
        this.isEcoleFilterApplied = true;
        this.filtreNiveau();
        this.filtreClasse();
        this.filtreEnseignant();
      } else {
        this.isEcoleFilterApplied = false;
        this.resetNiveau();
        this.filtreClasse();
        this.resetEnseignant();
      }
    },
    isEcoleFilterApplied(newval: boolean, oldval: boolean) {
      if (oldval && !newval) {
        this.resetNiveau();
        this.filtreClasse();
        this.resetEnseignant();
      } else {
        this.filtreNiveau();
        this.filtreClasse();
        this.filtreEnseignant();
      }
    },
    niveauSelected(newval: Array<number>, oldval: Array<number>) {
      if (newval.length !== 0) {
        this.isNiveauClasse = true;
        this.filtreClasse();
        this.filtreEnseignant();
      } else {
        this.isNiveauClasse = false;
        this.filtreClasse();
        this.resetEnseignant();
      }
    },
    isNiveauClasse(newval: boolean, oldval: boolean) {
      if (oldval && !newval) {
        this.filtreClasse();
        this.resetEnseignant();
      } else {
        this.filtreClasse();
        this.filtreEnseignant();
      }
    },
    classeSelected(newval: Array<number>, oldval: Array<number>) {
      if (newval.length !== 0) {
        this.isClasseInstit = true;
        this.filtreEnseignant();
      } else {
        this.isClasseInstit = false;
        this.resetEnseignant();
      }
    },
    isClasseInstit(newval: boolean, oldval: boolean) {
      if (oldval && !newval) {
        this.resetEnseignant();
      } else {
        this.filtreEnseignant();
      }
    },
    filtreScolarite: {
      handler(val: FiltreScolarite) {
        this.resetNiveau();
        this.resetClasse();
        this.resetEnseignant();
      },
      deep: true,
    },
    filtrePointage: {
      handler(val: FiltrePointage) {
        this.tempsSelected = (this.filtrePointage as FiltrePointage)
          .getListTemps()
          .map((temps: any) => temps.getId());
        this.supplementsSelected = (this.filtrePointage as FiltrePointage)
          .getListSuppplements()
          .map((supp: any) => supp.getId());
      },
      deep: true,
    },
  },
  props: {
    typeFiltre: {
      type: String,
      default: "",
    },
    listVille: {
      type: Array,
      default: () => [],
    },
    resetAll: {
      type: Boolean,
      default: false,
    },
    currentActivite: {
      type: Object,
      default: () => {},
    },
    filtreScolarite: {
      type: FiltreScolarite,
      default: () => new FiltreScolarite(),
    },
    filtrePointage: {
      type: FiltrePointage,
      default: () => new FiltrePointage(),
    },
  },
});
